/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTO } from '../models/ApiResponseDTO';
import type { ApiResponseDTOCreateAccountResponseDTO } from '../models/ApiResponseDTOCreateAccountResponseDTO';
import type { ApiResponseDTOOnboardingStepResponseDTO } from '../models/ApiResponseDTOOnboardingStepResponseDTO';
import type { ApiResponseDTOPersonalDetailsResponseDTO } from '../models/ApiResponseDTOPersonalDetailsResponseDTO';
import type { ApiResponseDTOSelfieStatusResponseDTO } from '../models/ApiResponseDTOSelfieStatusResponseDTO';
import type { ApiResponseDTOSubmitSelfieResponseDTO } from '../models/ApiResponseDTOSubmitSelfieResponseDTO';
import type { ApiResponseDTOUsersOnboardingResponseDTO } from '../models/ApiResponseDTOUsersOnboardingResponseDTO';
import type { ApiResponseDTOVoid } from '../models/ApiResponseDTOVoid';
import type { CreateAccountRequestDTO } from '../models/CreateAccountRequestDTO';
import type { CreateUserOnboardingRequestDTO } from '../models/CreateUserOnboardingRequestDTO';
import type { OnboardingBusinessInfoDTO } from '../models/OnboardingBusinessInfoDTO';
import type { PersonalDetailsRequestDTO } from '../models/PersonalDetailsRequestDTO';
import type { RegistrationTypeRequestDTO } from '../models/RegistrationTypeRequestDTO';
import type { SubmitOnboardingSelfieRequestDTO } from '../models/SubmitOnboardingSelfieRequestDTO';
import type { UsersOnboardingRequestDTO } from '../models/UsersOnboardingRequestDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OnboardingApiService {

    /**
     * Create new user
     * Register a new user onboarding, user will be registered only when the table fields are informed
     * @param requestBody
     * @returns ApiResponseDTOVoid Created
     * @throws ApiError
     */
    public static createNewUserOnboarding(
        requestBody: CreateUserOnboardingRequestDTO,
    ): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onboarding',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Create Account / Finish Sign-Up
     * This service allow the user to create the account on Zenz platform.
     * @param requestBody
     * @returns ApiResponseDTOCreateAccountResponseDTO Created
     * @throws ApiError
     */
    public static createAccount(
        requestBody: CreateAccountRequestDTO,
    ): CancelablePromise<ApiResponseDTOCreateAccountResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onboarding/account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Set user business info
     * Set user business info before complete the sign up
     * @param requestBody
     * @returns ApiResponseDTO OK
     * @throws ApiError
     */
    public static setBusinessInformation(
        requestBody: OnboardingBusinessInfoDTO,
    ): CancelablePromise<ApiResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onboarding/business-info',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Save personal details
     * Set the user personal details before complete the sing up
     * @param requestBody
     * @returns ApiResponseDTOPersonalDetailsResponseDTO OK
     * @throws ApiError
     */
    public static setPersonalDetails(
        requestBody: PersonalDetailsRequestDTO,
    ): CancelablePromise<ApiResponseDTOPersonalDetailsResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onboarding/personal-details',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get Registration Status
     * Get the registration status for this merchant, so that he can continue from where he stopped
     * @param userExternalId
     * @returns ApiResponseDTOOnboardingStepResponseDTO OK
     * @throws ApiError
     */
    public static getRegistrationStatus(
        userExternalId: string,
    ): CancelablePromise<ApiResponseDTOOnboardingStepResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/onboarding/registration-status/{userExternalId}',
            path: {
                'userExternalId': userExternalId,
            },
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Set Registration Type
     * Set the registration type for this merchant, the registration type will determine the user journey and documents required
     * @param requestBody
     * @returns ApiResponseDTOOnboardingStepResponseDTO OK
     * @throws ApiError
     */
    public static setRegistrationType(
        requestBody: RegistrationTypeRequestDTO,
    ): CancelablePromise<ApiResponseDTOOnboardingStepResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onboarding/registration-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Submit selfie during onboarding
     * Submit selfie images for verification during the onboarding flow, before account creation.
     * @param requestBody
     * @returns ApiResponseDTOSubmitSelfieResponseDTO OK
     * @throws ApiError
     */
    public static submitOnboardingSelfie(
        requestBody: SubmitOnboardingSelfieRequestDTO,
    ): CancelablePromise<ApiResponseDTOSubmitSelfieResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onboarding/selfie',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Check onboarding selfie status
     * Check the status of a selfie verification submitted during onboarding.
     * @param jobId
     * @returns ApiResponseDTOSelfieStatusResponseDTO OK
     * @throws ApiError
     */
    public static getOnboardingSelfieStatus(
        jobId: string,
    ): CancelablePromise<ApiResponseDTOSelfieStatusResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/onboarding/selfie/{jobId}',
            path: {
                'jobId': jobId,
            },
            errors: {
                400: `Bad Request`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Submit Selfie (Multipart) during onboarding
     * Submit selfie and liveness photos as multipart file uploads during onboarding
     * @param formData
     * @returns ApiResponseDTOSubmitSelfieResponseDTO OK
     * @throws ApiError
     */
    public static submitOnboardingSelfieMultipart(
        formData?: {
            files: Array<Blob>;
            metadata: string;
        },
    ): CancelablePromise<ApiResponseDTOSubmitSelfieResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/onboarding/upload-selfie',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Create Login PIN as zenith customer
     * Find zenith customer by account number to create the login PIN as zenith costumer
     * @param requestBody
     * @returns ApiResponseDTOUsersOnboardingResponseDTO OK
     * @throws ApiError
     */
    public static setCustomerAccount(
        requestBody: UsersOnboardingRequestDTO,
    ): CancelablePromise<ApiResponseDTOUsersOnboardingResponseDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/onboarding/zenith-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
